import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load page components
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Application = lazy(() => import('./pages/Application'));
const Partner = lazy(() => import('./pages/Partner'));
const Institution = lazy(() => import('./pages/Institution'));

// Transition component for page transitions
const Transition = ({ children }) => {
  const location = useLocation();
  const [isMounted, setIsMounted] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(() => {
    if (location !== currentLocation) {
      setIsTransitioning(true);
      const timer = setTimeout(() => {
        setCurrentLocation(location);
        setIsTransitioning(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location, currentLocation]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner size="lg" text="Loading..." />
      </div>
    }>
      <div
        className={`transition-opacity duration-300 ${isMounted ? 'opacity-100' : 'opacity-0'}`}
        style={{
          opacity: isTransitioning ? 0 : 1,
        }}
      >
        {children}
      </div>
    </Suspense>
  );
};

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Transition><Home /></Transition>} />
        <Route path="/login" element={<Transition><Login /></Transition>} />
        <Route path="/register" element={<Transition><Register /></Transition>} />
        <Route path="/forgot-password" element={<Transition><ForgotPassword /></Transition>} />
        <Route path="/reset-password" element={<Transition><ResetPassword /></Transition>} />
        <Route path="/application" element={<Transition><Application /></Transition>} />
        <Route path="/partner" element={<Transition><Partner /></Transition>} />
        <Route path="/institution" element={<Transition><Institution /></Transition>} />
      </Routes>
      <ScrollToTop />
    </div>
  );
}

export default App;